import styled from 'styled-components'

export const CreateWalletSwapper = styled.main`
  width: min(100% - 32px, 1000px);
  margin: 28px auto 48px;
  color: #25334b;
  @media (max-width: 768px) { width: min(100% - 24px, 560px); margin: 16px auto 32px; }
`

export const Header = styled.section`
  position: relative;
  overflow: hidden;
  padding: 34px;
  border: 1px solid rgba(31, 199, 212, 0.18);
  border-radius: 24px;
  background: radial-gradient(circle at 94% 6%, rgba(31, 199, 212, 0.2), transparent 27%), linear-gradient(135deg, #fff 0%, #f0fcfc 100%);
  box-shadow: 0 18px 44px rgba(31, 75, 91, 0.1);
  &::after { position: absolute; top: -85px; right: 8%; width: 190px; height: 190px; border: 28px solid rgba(31, 199, 212, 0.07); border-radius: 50%; content: ''; pointer-events: none; }
  .hero { position: relative; z-index: 1; display: flex; align-items: flex-start; gap: 15px; margin-bottom: 28px; }
  .hero-icon { display: grid; width: 46px; height: 46px; flex: 0 0 auto; place-items: center; border-radius: 15px; color: #fff; background: linear-gradient(135deg, #1fc7d4, #139fac); box-shadow: 0 9px 18px rgba(31, 199, 212, 0.25); }
  h1 { margin: 0; color: #19324d; font-size: clamp(21px, 3vw, 28px); font-weight: 800; line-height: 1.25; }
  .subtitle { margin: 7px 0 0; color: #718097; font-size: 14px; line-height: 1.65; }
  .createWallet { position: relative; z-index: 1; display: grid; grid-template-columns: minmax(180px, 1fr) auto auto; gap: 12px; align-items: stretch; }
  .creatInput { height: 46px; border: 1px solid #dce7ec; border-radius: 12px; color: #263b55; font-size: 14px; }
  .creatInput:focus { border-color: #1fc7d4; box-shadow: 0 0 0 3px rgba(31, 199, 212, 0.14); outline: 0; }
  .ant-btn { height: 46px; padding: 0 20px; border-radius: 12px; font-weight: 700; box-shadow: none; }
  .create-btn { border-color: #1fc7d4; color: #fff; background: linear-gradient(135deg, #1fc7d4, #139fac); box-shadow: 0 8px 16px rgba(31, 199, 212, 0.2); }
  .create-btn:hover, .create-btn:focus { border-color: #139fac; color: #fff; background: linear-gradient(135deg, #21d2df, #139fac); }
  .export-btn { border-color: #cfe1e7; color: #26717a; background: #fff; }
  .export-btn:hover, .export-btn:focus { border-color: #1fc7d4; color: #158e98; }
  .notice { position: relative; z-index: 1; display: flex; gap: 8px; align-items: center; margin: 17px 0 0; color: #a36a18; font-size: 13px; line-height: 1.5; }
  @media (max-width: 768px) { padding: 24px 18px 20px; border-radius: 20px; .hero { gap: 12px; margin-bottom: 22px; } .hero-icon { width: 40px; height: 40px; border-radius: 13px; } .subtitle { font-size: 13px; } .createWallet { grid-template-columns: 1fr 1fr; gap: 10px; } .createWallet > div { grid-column: 1 / -1; } .ant-btn { padding: 0 10px; } }
`

export const ResultHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 30px 4px 14px;
  h2 { margin: 0; color: #24354f; font-size: 17px; font-weight: 800; }
  span { color: #6b7b91; font-size: 13px; }
  @media (max-width: 768px) { margin-top: 24px; }
`

export const EmptyState = styled.div`
  padding: 42px 24px;
  border: 1px dashed #c8e3e6;
  border-radius: 20px;
  color: #8090a4;
  text-align: center;
  background: rgba(255, 255, 255, 0.6);
  font-size: 14px;
`
